export default "__VITE_ASSET__DzveW3UA__"